import AnalyticsEquipment from "./analyticsEquipment";
export default AnalyticsEquipment;
